import { Segmented } from 'antd';
import { useState } from 'react';
import type { OverviewResponse } from '../contract';
import { Donut } from './mix-donut';
import styles from '../style.module.scss';
import more from '../style-more.module.scss';

type View = 'tier' | 'maturity';

/** Donut "Trạng thái TikTok": bậc (Đã tăng bậc / Được duy trì / Không duy trì được) hoặc trưởng thành. */
const StatusDonut = ({ ov }: { ov: OverviewResponse }) => {
  const [view, setView] = useState<View>('tier');
  const mix = ov.statusMix;
  if (!mix) return null;
  const rows = view === 'tier' ? mix.tier : mix.maturity;
  return (
    <section className={styles.card} aria-label="Trạng thái TikTok">
      <div className={styles.cardHead}>
        <h2 className={styles.cardTitle}>Trạng thái TikTok</h2>
        <Segmented<View>
          size="small"
          value={view}
          onChange={(v) => setView(v as View)}
          options={[
            { label: 'Bậc', value: 'tier' },
            { label: 'Trưởng thành', value: 'maturity' },
          ]}
        />
      </div>
      <Donut
        unit="Creator"
        emptyText="Chưa có trạng thái nào."
        slices={rows.map((r) => ({ name: r.label, value: r.creators }))}
      />
      {view === 'tier' && mix.source === 'MONTH_FILE' && ov.tiktokMonth?.full === false && (
        <p className={more.note}>
          File tháng {ov.tiktokMonth.period || ''} chưa trọn tháng — trạng thái bậc chỉ chốt ở file cả
          tháng (cuối tháng).
        </p>
      )}
      {view === 'tier' && mix.source === 'DAY' && (
        <p className={more.note}>
          Trạng thái bậc chỉ có ý nghĩa ở file tháng (cuối tháng): giữa tháng TikTok ghi gần như mọi
          Creator là &quot;Không duy trì được&quot;.
        </p>
      )}
    </section>
  );
};

export default StatusDonut;
